import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import AdvancedSelectFormik from "app/pages/.shared/form/AdvancedSelectFormik/AdvancedSelectFormik";
import { memo, useContext } from "react";
import AppGlobalsContext from "app/AppGlobalsContext";
import SmartDPInputSidePanelContent from "app/pages/SmartDP/Search/SDPSearchForm/SmartDPInputSidePanelContent";
import FloatingAdvancedSelectFormik from "app/pages/.shared/form/FloatingAdvancedSelectFormik/FloatingAdvancedSelectFormik";
import FloatingDestinationCombobox from "../../../.shared/form/FloatingAdvancedSelectFormik/FloatingDestinationCombobox";

const SmartDPSearchInput = props => {
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	if (isMobile) {
		return <SmartDPInputSidePanelContent {...props} />;
	}
	if (props?.isFloating && props?.useDestinationCombobox) {
		return <FloatingDestinationCombobox {...props} />;
	}
	if (props?.isFloating) {
		return <FloatingAdvancedSelectFormik {...props} />;
	}
	return <AdvancedSelectFormik {...props} />;
};
export default memo(SmartDPSearchInput);
